/**
 * Vue Example
 */

import { App } from '~/app';

import { defineAsyncComponent } from 'vue';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Vue Example Component');

    // These Vue components are not used - commenting out to prevent compilation in the completed bundle
    app.vueApp.component('stockland-vue-example', defineAsyncComponent(async () => import("./StocklandVueExample.vue")));
};
